export default __webpack_public_path__ + "static/media/Banner - Elevate x Swarovski.f8e5b5b4.jpg";